<script>
import settings from '@/settings.js';

export default {
	name: 'SpOrderStatusFilterDropdown',
	methods: {
		click_item (item) {
			this.allSelected = false;
			this.selectItem(item.value);
			this.$emit('change', this.selectedItems);
		},
		click_all (evt) {
			this.selectItem();
			this.allSelected = true;
			this.$emit('change', []);
		},
		selectItem (value) {
			this.selectedItems = [];
			for (let item of this.items) {
				if (this.multiselect) {
					if (value) {
						if (value === item.value) {
							item.active = !item.active;
						}
					} else {
						item.active = false;
					}
				} else {
					if (value) {
						if (value === item.value) {
							item.active = true;
						} else {
							item.active = false;
						}
					} else {
						item.active = false;
					}
				}
				if (item.active) {
					this.selectedItems.push(item);
				}
			}
			if (this.selectedItems.length === 0) {
				this.allSelected = true;
			}
		},
		clear () {
			this.selectItem();
		}
	},
	computed: {
		selectedTitle () {
			return this.defaultItemLabel;
		},
		profile () {
			return this.$store.getters.getProfile;
		},
		items () {
			if (this.$store.getters.getUserSpOrdersStatusFilter && this.$store.getters.getUserSpOrdersStatusFilter.length > 0) {
				this.allSelected = false;
				this.$store.getters.getUserSpOrdersStatusFilter.forEach(el => {
					this.settings.spOrderItemsStatusOptions.find((item) => {
						if (item.value === el) {
							item.active = true;
						}
					});
				});
				return this.settings.spOrderItemsStatusOptions;
			} else {
				return this.settings.spOrderItemsStatusOptions.map(el => ({...el, active: false}));
			}
		}
	},
	data: () => {
		return {
			defaultItemLabel: 'Vse',
			selectedItems: [],
			multiselect: true,
			allSelected: true,
			settings
		}
	}
}
</script>
<template>
<b-dropdown variant="primary" :text="selectedTitle" ref="dropdown">
	 <template #button-content>
		<span v-if="allSelected">Vse</span>
		<span v-else v-for="item in items" :key="item.value" >
			<span v-if="item.active">
				<b-badge :variant="item.variant">{{ item.label }}</b-badge>
			</span>
		</span>
	 </template>
	<b-dropdown-header>Status</b-dropdown-header>
	<b-dropdown-item @click="click_item(item)" v-for="item in items" :key="item.value" :active="item.active">
		<b-badge class="text-wrap" :variant="item.variant">{{ item.label }}</b-badge>
	</b-dropdown-item>
	<b-dropdown-divider></b-dropdown-divider>
	<b-dropdown-item @click="click_all" :active="allSelected">{{ defaultItemLabel }}</b-dropdown-item>
</b-dropdown>
</template>
<style>
</style>